import { ChangeDetectionStrategy, Component, OnInit, Type, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AppFacade } from 'ish-core/facades/app.facade';
import { CMSFacade } from 'ish-core/facades/cms.facade';

@Component({
  selector: 'custom-content-page-selection',
  templateUrl: './content-page-selection.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ContentPageSelectionComponent implements OnInit {
  isContentPage$: Observable<boolean>;
  private cmsFacade = inject(CMSFacade);
  private appFacade = inject(AppFacade);

  lazyPageComponent$: Observable<Type<unknown>> = this.appFacade.loadLazyComponent('page');
  ngOnInit(): void {
    this.isContentPage$ = this.cmsFacade.isContentPage$();
  }
}
